import loader from '../moduleLoader.js';
import Overlay from '../Overlay/Overlay.js';

class Subscription {
    constructor(submitButton) {
        this.submitButton = submitButton;
        this.successMessage = submitButton.dataset.successMessage;
        this.emailError = submitButton.dataset.emailError;
        this.selectionError = submitButton.dataset.selectionError;
        this.errorMessage = submitButton.dataset.errorMessage;
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.postFormData = this.postFormData.bind(this);
    }
    init() {
        this.submitButton.addEventListener('click', this.handleFormSubmit);        
    }
    handleFormSubmit(e) {
        e.preventDefault();
        var error = false;
        document.getElementById('SubscribeEmailValidationMessage').innerHTML = "";
        document.getElementById('SubscribeValidationMessage').innerHTML = "";
        if (!this.validateEmailInput(e.target.form)) {
            error = true;
            document.getElementById('SubscribeEmailValidationMessage').innerHTML = this.emailError;
        }
        if (!this.validateSelectionInput(e.target.form)) {
            error = true;
            document.getElementById('SubscribeValidationMessage').innerHTML = this.selectionError;
        }

        if (error === false) {
            e.target.style.width = e.target.offsetWidth + 'px';
            e.target.dataset.loading = true;
            this.postFormData(e.target.form).then((html) => {
                document.getElementById('Subscription').innerHTML = html;
            });
        }
    }
    postFormData(form) {
        return new Promise(resolve => {
            const formData = new FormData(form);
            fetch(form.action, {
                method: "POST",
                body: formData
            }).then(response => {                
                if(!response.ok) {                    
                    resolve(this.errorMessage);
                }           
                return response.text();
            }).then(responseText => {
                if(responseText !== 'success') {
                    resolve(this.errorMessage);
                }
                else {
                    resolve(this.successMessage);
                }
            }).catch(error => {
                console.error(error);
                resolve(this.errorMessage);
            });  
        });
    }

    validateSelectionInput(form) {
        if (form.querySelector('[name=informationtype]:checked') == null) {
            return false;
        }
        return true;
    }

    validateEmailInput(form) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(form.querySelector('[type=email]').value.toLowerCase())) {
            return false;
        }
        return true;
    }

}

loader.add('Subscription', Subscription);

export default Subscription;
